// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"e7310a9f","46":"3cfffa3e","382":"09163b05","455":"c0d9418d","477":"4eead410","580":"ac033d7d","630":"72b0311a","787":"22f34b33","820":"5128cea4","838":"29370911"}[chunkId] + ".chunk.js";
};